export default function getCssPropertiesFromAmbiguousStyleInput(styleInput) {
    if (!styleInput)
        return {};
    let result = {};
    if (typeof styleInput === 'string') {
        // Process string input
        styleInput.split('').forEach(s => {
            const [key, value] = s.trim().split(':').map(item => item.trim());
            if (key && value !== undefined) {
                // @ts-ignore
                result[key] = value === '0' ? 0 : value;
            }
        });
    }
    else if (Array.isArray(styleInput)) {
        // Process each array member
        styleInput.forEach((cssObject) => {
            if (typeof cssObject === 'object' && cssObject !== null) {
                result = Object.assign(Object.assign({}, result), cssObject);
            }
        });
    }
    else if (typeof styleInput === 'object' && styleInput !== null) {
        // Directly merge if it's an object
        result = Object.assign(Object.assign({}, result), styleInput);
    }
    return result;
}
